import { HTMLAttributes } from 'react'

export default (props: HTMLAttributes<SVGElement>) => (
  <svg
    {...props}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_101_2)'>
      <path
        d='M9.5 15.25C12.6756 15.25 15.25 12.6756 15.25 9.5C15.25 6.32436 12.6756 3.75 9.5 3.75C6.32436 3.75 3.75 6.32436 3.75 9.5C3.75 12.6756 6.32436 15.25 9.5 15.25Z'
        stroke='currentColor'
        strokeWidth='1.5'
      />
      <path
        d='M14 14.5L19.6569 20.1569'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='square'
      />
      <line x1='9.5' y1='6' x2='9.5' y2='13' stroke='currentColor' />
      <line x1='13' y1='9.5' x2='6' y2='9.5' stroke='currentColor' />
    </g>
    <defs>
      <clipPath id='clip0_101_2'>
        <rect width='24' height='24' fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
)
